/* eslint-disable */
function loadImage(src, callback) {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = function () {
            resolve(img);
            callback?.();
        };
        img.onerror = img.onabort = function () {
            reject(src);
            callback?.();
        };

        img.src = src;
    });
}

function preloadImages(images, callback) {
    return Promise.allSettled(images.map(src => loadImage(src, callback)));
}

export {
    preloadImages
};
